module.exports = __webpack_public_path__ + "static/media/service (1).b39817c3.svg";